import { HistoryOutlined, HomeOutlined } from "@mui/icons-material";
import { Box, Button, Sheet } from "@mui/joy";
import * as React from "react";
import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import styles from "./Tabcontainer.module.css";

const Tabcontainer = ({ tabcontainerHeight, tabcontainerTop }) => {
  const tabcontainerStyle = useMemo(() => {
    return {
      height: tabcontainerHeight,
      top: tabcontainerTop,
    };
  }, [tabcontainerHeight, tabcontainerTop]);

  const tabStyleactive = useMemo(() => {
    return {
      backgroundColor: "#0052ff",
    };
  });

  const tabStyle = useMemo(() => {
    return {
      backgroundColor: "transparent",
    };
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log(location);
  });

  const ishome = location.pathname === "/";
  const isActivity = location.pathname === "/activity";
  const isCard = location.pathname === "/card";

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        position: "fixed",
        top: "88%",
        zIndex: 10000,
        padding: "0px 10px 10px 10px",
        background: "transparent",
      }}
    >
      <Sheet variant="outlined" className={styles.tabs}>
        <Button
          sx={{ borderRadius: 38 }}
          onClick={() => navigate("/")}
          className={styles.tab}
          variant="solid"
          // style={ishome ? tabStyleactive : tabStyle}
          color={ishome ? "primary" : "plain"}
        >
          <HomeOutlined sx={{ fontSize: "2.1rem" }} color="inherit" />
        </Button>
        <Button
          sx={{ borderRadius: 38 }}
          onClick={() => navigate("/activity")}
          className={styles.tab}
          variant="solid"
          color={isActivity ? "primary" : "plain"}
        >
          <HistoryOutlined sx={{ fontSize: "2.1rem" }} color="inherit" />
        </Button>
      </Sheet>
    </Box>
  );
};

export default Tabcontainer;
